module.exports = __webpack_public_path__ + "img/delete.0c42b45f.png";